import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'exchangeRate';

const exchangeRateService = {
  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  getDailyRate: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/dailyRate`,
      data,
    });
  },
};
export default exchangeRateService;
